









// vue
import { defineComponent, ref, watch } from '@vue/composition-api';

// components
import EditorText from '@/vue3/components/editor/EditorText.vue';

export default defineComponent({
    props: {
        value: {
            type: Object,
            default: () => {},
        },
    },
    components: {
        EditorText,
    },
    setup(props: any, { emit }) {
        const localValue = ref<any>((props.value||{}).value);

        watch(localValue, (newValue) => {
            emit('input', { ...props.value, value: newValue, displayValue: newValue ? newValue : '' });
        });

        return {
            localValue
        };
    },
});
